import { all, post, spread } from 'axios';
import { encodeFormData } from '../../helpers/encode-form-data';

const { console, price, productCode, setupFee } = window;

export default {
  el: '#main',
  data: {
    form: {
      first_name: '',
      email: '',
      URL: '',
      promoCode: '',
      billing: 'Bill Volusion account',
      productCode,
      setupFee,
      price
    },
    views: {
      thankyou: false
    },
    total: false
  },
  methods: {
    setTotal() {
      let p;
      let s;

      if (this.form.price && this.form.setupFee) {
        p = parseFloat(this.form.price.replace(/[^0-9.]|,/g, ''));
        s = parseFloat(this.form.setupFee.replace(/[^0-9.]|,/g, ''));
        this.total = (p + s).toFixed(2);
      }
    },
    showThankYou() {
      this.views.thankyou = true;
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    validateForm(e) {
      e.preventDefault();

      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.views.email = true;
          return false;
        }

        all([this.sendServices(), this.sendPardot()])
          .then(spread(this.processResponses))
          .catch(this.error);

        this.showThankYou();
      });
    },
    processResponses(services, pardot) {
      console.log('services', services);
      console.log('pardot', pardot);
    },
    error(error) {
      console.error(error);
    },
    sendPardot() {
      const firstName = this.form.first_name
        .split(' ')
        .slice(0, -1)
        .join(' ');
      const lastName = this.form.first_name
        .split(' ')
        .slice(-1)
        .join(' ');

      const pardotObject = {
        email: this.form.email,
        first_name: firstName,
        last_name: lastName,
        list_price: this.form.price,
        payment_method: this.form.billing,
        product_code: this.form.productCode,
        promo_code: this.form.promoCode,
        setup_fee: this.form.setupFee,
        store_url: this.form.URL
      };

      return post(
        'https://go.pardot.com/l/513691/2018-11-16/8nmjdj',
        pardotObject, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: '*/*'
          },
          withCredentials: true,
          transformRequest: [encodeFormData]
        }
      );
    },
    sendServices() {
      return post(
        'https://mrkt-api-mailchimp.appspot.com/api/v2/services',
        this.form
      );
    }
  },
  mounted: function() {
    this.setTotal();
  }
};